<template>
    <div class="Com_view">
        <div class="box_header">
            <!-- <el-image :src="require('../assets/image/bg_1.jpg')"></el-image> -->
        </div>
        <div class="box_section">
            <div class="box_title">
                <span>拥有5000+合作伙伴 / 产品分布范围广</span>
            </div>
            <div class="box_map">
                <dv-flyline-chart-enhanced :dev="true" :config="config" style="width:100%;height: 100%;margin:0 auto;" />
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            config: {
                points: [
                    {
                        name: '0',
                        coordinate: [0.65, 0.84],
                    },
                    {
                        name: '1',
                        coordinate: [0.60, 0.93]
                    },
                    {
                        name: '2',
                        coordinate: [0.63, 0.86]
                    },
                    {
                        name: '3',
                        coordinate: [0.63, 0.86]
                    },
                    {
                        name: '4',
                        coordinate: [0.66, 0.80]
                    },
                    {
                        name: '5',
                        coordinate: [0.68, 0.81]
                    },
                    {
                        name: '6',
                        coordinate: [0.69, 0.83]
                    },
                    {
                        name: '7',
                        coordinate: [0.70, 0.81]
                    },
                    {
                        name: '8',
                        coordinate: [0.69, 0.83]
                    },
                    {
                        name: '9',
                        coordinate: [0.59, 0.80]
                    },
                    {
                        name: '10',
                        coordinate: [0.74, 0.72]
                    },
                    {
                        name: '11',
                        coordinate: [0.75, 0.74]
                    },
                    {
                        name: '12',
                        coordinate: [0.69, 0.72]
                    },
                    {
                        name: '13',
                        coordinate: [0.64, 0.73]
                    },
                    {
                        name: '14',
                        coordinate: [0.63, 0.70]
                    },
                    {
                        name: '15',
                        coordinate: [0.56, 0.72]
                    },
                    {
                        name: '16',
                        coordinate: [0.45, 0.78]
                    },
                    {
                        name: '17',
                        coordinate: [0.74, 0.66]
                    },
                    {
                        name: '18',
                        coordinate: [0.67, 0.65]
                    },
                    {
                        name: '19',
                        coordinate: [0.66, 0.66]
                    },
                    {
                        name: '20',
                        coordinate: [0.66, 0.63]
                    },
                    {
                        name: '21',
                        coordinate: [0.63, 0.62]
                    },
                    {
                        name: '22',
                        coordinate: [0.57, 0.64]
                    },
                    {
                        name: '23',
                        coordinate: [0.55, 0.66]
                    },
                    {
                        name: '24',
                        coordinate: [0.50, 0.63]
                    },
                    {
                        name: '25',
                        coordinate: [0.36, 0.63]
                    },
                    {
                        name: '26',
                        coordinate: [0.25, 0.51]
                    },
                    {
                        name: '27',
                        coordinate: [0.78, 0.60]
                    },
                    {
                        name: '28',
                        coordinate: [0.77, 0.62]
                    },
                    {
                        name: '29',
                        coordinate: [0.77, 0.60]
                    },
                    {
                        name: '30',
                        coordinate: [0.75, 0.61]
                    },
                    {
                        name: '31',
                        coordinate: [0.75, 0.58]
                    },
                    {
                        name: '32',
                        coordinate: [0.71, 0.58]
                    },
                    {
                        name: '33',
                        coordinate: [0.67, 0.56]
                    },
                    {
                        name: '34',
                        coordinate: [0.65, 0.53]
                    },
                    {
                        name: '35',
                        coordinate: [0.63, 0.55]
                    },
                    {
                        name: '36',
                        coordinate: [0.56, 0.56]
                    },
                    {
                        name: '37',
                        coordinate: [0.53, 0.53]
                    },
                    {
                        name: '38',
                        coordinate: [0.37, 0.51]
                    },
                    {
                        name: '39',
                        coordinate: [0.70, 0.48]
                    },
                    {
                        name: '40',
                        coordinate: [0.70, 0.37]
                    },
                    {
                        name: '41',
                        coordinate: [0.68, 0.40]
                    },
                    {
                        name: '42',
                        coordinate: [0.66, 0.41]
                    },
                    {
                        name: '43',
                        coordinate: [0.66, 0.38]
                    },
                    {
                        name: '44',
                        coordinate: [0.49, 0.38]
                    },
                    {
                        name: '45',
                        coordinate: [0.34, 0.36]
                    },

                ],
                lines: [
                    {
                        source: '1',
                        target: '0'
                    },
                    {
                        source: '2',
                        target: '0'
                    },
                    {
                        source: '3',
                        target: '0'
                    },
                    {
                        source: '4',
                        target: '0'
                    },
                    {
                        source: '5',
                        target: '0'
                    },
                    {
                        source: '6',
                        target: '0'
                    },
                    {
                        source: '7',
                        target: '0'
                    },
                    {
                        source: '8',
                        target: '0'
                    },
                    {
                        source: '9',
                        target: '0'
                    },
                    {
                        source: '10',
                        target: '0'
                    },
                    {
                        source: '11',
                        target: '0'
                    },
                    {
                        source: '12',
                        target: '0'
                    },
                    {
                        source: '13',
                        target: '0'
                    },
                    {
                        source: '14',
                        target: '0'
                    },
                    {
                        source: '15',
                        target: '0'
                    },
                    {
                        source: '16',
                        target: '0'
                    },
                    {
                        source: '17',
                        target: '0'
                    },
                    {
                        source: '18',
                        target: '0'
                    },
                    {
                        source: '19',
                        target: '0'
                    },
                    {
                        source: '20',
                        target: '0'
                    },
                    {
                        source: '21',
                        target: '0'
                    },
                    {
                        source: '22',
                        target: '0'
                    },
                    {
                        source: '23',
                        target: '0'
                    },
                    {
                        source: '24',
                        target: '0'
                    },
                    {
                        source: '25',
                        target: '0'
                    },
                    {
                        source: '26',
                        target: '0'
                    },
                    {
                        source: '27',
                        target: '0'
                    },
                    {
                        source: '28',
                        target: '0'
                    },
                    {
                        source: '29',
                        target: '0'
                    },
                    {
                        source: '30',
                        target: '0'
                    },
                    {
                        source: '31',
                        target: '0'
                    },
                    {
                        source: '32',
                        target: '0'
                    },
                    {
                        source: '33',
                        target: '0'
                    },
                    {
                        source: '34',
                        target: '0'
                    },
                    {
                        source: '35',
                        target: '0'
                    },
                    {
                        source: '36',
                        target: '0'
                    },
                    {
                        source: '37',
                        target: '0'
                    },
                    {
                        source: '38',
                        target: '0'
                    },
                    {
                        source: '39',
                        target: '0'
                    },
                    {
                        source: '40',
                        target: '0'
                    },
                    {
                        source: '41',
                        target: '0'
                    },
                    {
                        source: '42',
                        target: '0'
                    },
                    {
                        source: '43',
                        target: '0'
                    },
                    {
                        source: '44',
                        target: '0'
                    },
                    {
                        source: '45',
                        target: '0'
                    },

                ],
                bgImgSrc: require('../assets/partner/map_1.png'),
            },
        };
    },
    created() { },
    methods: {},
    mounted() { }
};
</script>
<style lang="less" scoped>
@media all and (max-width: 768px) {
    .Com_view {
        .box_section {
            .box_map {
                height: 65vw !important;
                padding: 30px 0 !important;
            }
        }
    }
}
</style>
<style lang="less" scoped>
.Com_view {
    border-bottom: 1px dashed #DCDCDA;
    padding-bottom: 40px;

    .box_header {
        height: 30vw;
        min-height: 200px;
        background-image: url('../assets/image/bg_1.jpg');
        overflow: hidden;
        background-repeat: no-repeat;
        background-size: cover;
        background-position:center center;
    }

    .box_section {
        margin-top: 20px;
        overflow: hidden;
        .box_title {
            margin: 40px 0 20px 0;
            text-align: center;
            font-size: 20px;
            color: #67289C;
            span{
                margin: 10px;
            }
        }

        .box_map {
            height: 30vw;
            padding: 0 25%;

        }
    }
}
</style>